import * as React from "react";

export function NotFoundPage() {
  // Existing pre-react behaviour where not found pages redirect to index
  window.location.href = "/";
  return <></>;
}
